module.exports = __webpack_public_path__ + "static/img/Spring Blossom.08f46a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Spring Blossom.jpg
// module id = jmvZ
// module chunks = 0